export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldAddSpecificItemDiscountsForCashierValidation: 'specs.stores.ShouldAddSpecificItemDiscountsForCashierValidation'
};
//# sourceMappingURL=SPECS.js.map